<div class="summary-panel br-large">
  <div class="panel-row no-bb" *ngIf="refExternalResourceExp && refExternalResourceExp.length">
    <table>
      <tr>
        <th>{{ 'general.name' | translate }}</th>
        <th class="aright">{{ 'general.daysLeft' | translate }}</th>
      </tr>
      <tr *ngFor="let record of refExternalResourceExp">
        <td class="grid-data">
          <span>{{ record.nameEn }}</span>
        </td>
        <td class="aright">
          <span *ngIf="record.daysLeft <= 0">{{ 'referenceTables.expired' | translate }}</span>
          <span *ngIf="record.daysLeft > 0">{{ record.daysLeft }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div *ngIf="!refExternalResourceExp.length">
    <div class="dx-datagrid-nodata">{{ 'general.noDataToDisplay' | translate }}</div>
  </div>
</div>
